<template>
  <!-- 因為某些modal為後端套版，因此需建立一個空的組件以提供Modal進行動態載入 -->
  <div />
</template>
